import React, { useEffect, useState } from "react";
import Menu from './Menu.js';
import Homepage from './Homepage.js';
import {useNavigate} from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { ThemeProvider } from '@mui/material/styles';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import TextField from '@mui/material/TextField';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import SaveIcon from '@mui/icons-material/Save';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import Chip from '@mui/material/Chip';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import CancelIcon from '@mui/icons-material/Cancel';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { useAuth0 } from "@auth0/auth0-react";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Barcode from 'react-barcode';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { createTheme } from '@mui/material/styles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import ImageIcon from '@mui/icons-material/Image';
import WorkIcon from '@mui/icons-material/Work';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import StraightenIcon from '@mui/icons-material/Straighten';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import InventoryIcon from '@mui/icons-material/Inventory';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import CategoryIcon from '@mui/icons-material/Category';
import NumbersIcon from '@mui/icons-material/Numbers';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';

const theme = createTheme({
  palette: {
    ochre: {
      main: '#FFF',
      light: '#FCFCFC',
      dark: '#F1F1F1',
      contrastText: '#000',
    },
  },
});

function srcset(image, width, height, rows = 1, cols = 1) {
  return {
    src: `${image}?w=${width * cols}&h=${height * rows}&fit=crop&auto=format`,
    srcSet: `${image}?w=${width * cols}&h=${
      height * rows
    }&fit=crop&auto=format&dpr=2 2x`,
  };
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    body: {
      backgroundColor: '#eee',
      height: '100vh',
      margin: '0'
    },
    full_root: {
      background: 'linear-gradient(90deg,rgba(103, 4, 125, 1) 0%, rgba(143, 50, 186, 1) 55%, rgba(102, 6, 140, 1) 100%)',
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    root: {
      flexGrow: 1,
      margin: 'auto',
      maxWidth: 1600,
      //paddingTop: '55px'
    },
    logo: {
      position: 'absolute',
      top: '30px',
      left: '30px',
      borderRadius: '20px',
    },
    name: {
      fontFamily: 'Arial',
      fontWeight: 600,
      fontSize: 30,
    },
    icon: {
      width: '50px',
      height: '50px',
      backgroundColor: '#842c9c'
   },
   listItemText: {
      fontSize:'20px',
      fontWeight: 'bold'
    },
    listItemText_secondary: {
       fontSize:'20px'
     },
    item_list: {
       margin: '0px 20px 0px 20px'
     },
    paper: {
      padding: theme.spacing(2),
      margin: '0 auto 20px auto',
      maxWidth: 700,
    },
    paper_custom: {
      margin: '15px',
      marginLeft: '120px',
      align: 'center'
    },
    paper_details: {
      marginTop: '40px',
      borderRadius: '20px',
      paddingTop: '40px'
    },
    paper_image: {
      padding: '40px',
      minHeight: '200px',
      borderRadius: "20px"
    },
    title: {
      fontWeigh: 'bold',
      color: '#9452c0'
    },
    head_title: {
      margin: 'auto',
      fontSize: '30px',
      letterSpacing: '-1px'

    },
    head_main_title: {
      margin: 'auto',
      fontSize: '30px',
      color: '#000'
    },
    head_barcode: {
      marginTop: '20px',
      fontSize: '22px',
      marginBottom: '20px'
    },
    head_barcode_icon: {
      width: '100%',
      padding: '30px auto',
      fontSize: '55px',
      marginBottom: '10px',
      textAlign: 'center'
    },
    head_text: {
      margin: 'auto',
      fontSize: '15px',
      marginBottom: '2px',
    },
    head_price: {
      margin: 'auto',
      fontSize: '30px'
    }
  }),
);



const Product = (props) => {

  const { isAuthenticated } = useAuth0();

  const [saveDisabled, setSaveDisabled] = React.useState(true);

  const queryParams = new URLSearchParams(window.location.search);
  const my_product_id = queryParams.get('id');



    const classes = useStyles();
    const navigate = useNavigate();

    const [number_of_variants, setNumber_of_variants] = useState("");
    const [title_website, setTitle_website] = useState("");
    const [title_website_changed, setTitle_website_changed] = useState(false);
    const [title_variant, setTitle_variant] = useState("");
    const [title_variant_changed, setTitle_variant_changed] = useState(false);
    const [description, setDescription] = useState("");
    const [description_changed, setDescription_changed] = useState(false);
    const [tags, setTags] = useState("");
    const [tags_changed, setTags_changed] = useState(false);
    const [price, setPrice] = useState("");
    const [stock, setStock] = useState("");
    const [ean, setEan] = useState("");

    const [changingEan, setChangingEan] = useState("");

    const [nextEan, setNextEan] = useState("");

    const [variant, setVariant] = useState("");
    const [brand, setBrand] = useState("");
    const [brand_changed, setBrand_changed] = useState(false);
    const [color, setColor] = useState("");
    const [color_changed, setColor_changed] = useState(false);
    const [size, setSize] = useState("");
    const [size_changed, setSize_changed] = useState(false);
    const [weight, setWeight] = useState("");
    const [weight_changed, setWeight_changed] = useState(false);
    const [length, setLength] = useState("");
    const [length_changed, setLength_changed] = useState(false);
    const [width, setWidth] = useState("");
    const [width_changed, setWidth_changed] = useState(false);
    const [height, setHeight] = useState("");
    const [height_changed, setHeight_changed] = useState(false);
    const [product_type, setProduct_type] = useState("");
    const [product_type_changed, setProduct_type_changed] = useState(false);
    const [main_photo, setMain_photo] = useState("");
    const [main_photo_changed, setMain_photo_changed] = useState(false);
    const [stock_location, setStock_location] = useState("");
    const [stock_location_changed, setStock_location_changed] = useState(false);
    const [sold_Trend, setSold_Trend] = useState("");
    const [offer_Text, setOffer_Text] = useState("");
    const [price_Text, setPrice_Text] = useState("");
    const [margin_Text, setMargin_Text] = useState("");

    const onlyContainsNumbers = (str) => /^\d+$/.test(str);

    const onChange = (e) => {
        const { target: { name, value } } = e;

        if(name === 'ean'){
          setChangingEan(value);

          if(value.length === 13 && onlyContainsNumbers(value) && value != ean ){
              setNextEan(value);
              console.log('Correct EAN entered!')
              setChangingEan('');
          }
        }

        setSaveDisabled(false);
      };


        useEffect(() => {
                const url = '/api/get_product' + '?ean=' + nextEan; //my_product_id;

                const requestOptions = {
                  method: 'GET',
                  headers: { 'Authentication': 'Basic bGxveWQ6aG9ua2JhbA==' }
                };

                const fetchData = async () => {
                    try {
                        const response = await fetch(url, requestOptions);
                        const json = await response.json();

                        setNumber_of_variants(json[0]['number_of_variants'])

                        setTitle_website(json[0]['title_website'])
                        setTitle_variant(json[0]['variant_title'])
                        setDescription(json[0]['description'])
                        setTags(json[0]['tags'])


                        setPrice(json[0]['showroom_price'])
                        setStock(json[0]['stock'])
                        setEan(json[0]['ean'])
                        setVariant(json[0]['variant'])
                        setBrand(json[0]['brand'])
                        setColor(json[0]['color'])
                        setSize(json[0]['size'])
                        setWeight(json[0]['weight'])
                        setLength(json[0]['length'])
                        setWidth(json[0]['width'])
                        setHeight(json[0]['height'])
                        setProduct_type(json[0]['product_type'])
                        setMain_photo(json[0]['main_photo'])
                        setStock_location(json[0]['stock_location'])

                        setSold_Trend([json[0]['a'], json[0]['b'], json[0]['c'], json[0]['d'], json[0]['e']])

                        setOffer_Text('Listed on ' + json[0]['nr_of_marketplaces'] + ' marketplaces')

                        if(json[0]['min_price'] === json[0]['max_price']){
                          setPrice_Text('Price: €' + json[0]['min_price'])
                        }else{
                          setPrice_Text('Price range: €' + json[0]['min_price'] + ' - €' + json[0]['max_price'])
                        }

                        if(json[0]['min_margin'] === json[0]['max_margin']){
                          setMargin_Text('Margin: ' + json[0]['min_margin'])
                        }else{
                          setMargin_Text('Margin: ' + json[0]['min_margin'] + ' - ' + json[0]['max_margin'])
                        }



                   } catch (error) {
                       console.log("error", error);
                   }
               };

               fetchData();
           }, [nextEan]);


    const parseLines = (value) => value?.replace(/(\\n)/g, "\n") ?? "";


  if (isAuthenticated) {

  return (

    <div className={classes.full_root}>

    <Paper className={classes.logo} elevation='6'>
      <img alt="AAS_Logo"
        src="https://aasproductimages.s3.eu-central-1.amazonaws.com/AAS_Logo_Rond.png"
        height="80px"
        loading="lazy"
        style={{margin: '12px'}}
      />
    </Paper>
    <Grid container>


    <Grid item xs>

    <div>



      <div className={classes.root}>

        <Grid container justifyContent="center" alignItems="center">


        <Grid item xs={4}>


            <Paper className={classes.paper_image} elevation='6'>

            <div variant="body1" className={classes.head_barcode_icon}>
            <Typography variant="body1" className={classes.head_barcode}>
               <b>Scan barcode of zoek product via EAN</b>
              </Typography>
            </div>

                    <div>


                        <TextField
                          name="ean"
                          id="outlined-size-small"
                          value={changingEan}
                          size="large"
                          fullWidth
                          variant="outlined"
                          InputProps={{ style: { fontSize: 25, background: "#edf3fb" }}}
                          onChange={onChange}
                          inputRef={input => input && input.focus()}

                        />
                    </div>


          </Paper>

        </Grid>


        <Grid item xs={8}>

        {ean !== "" ?

            <Paper className={classes.paper_custom} elevation='4' style={{minHeight: '450px', borderRadius: "20px"}}>

              <div style={{padding: '40px auto', width: '100%', textAlign: 'center'}}>
              <img alt={main_photo?.split(',')?.[0] ?? ""}
                src={main_photo?.split(',')?.[0] ?? ""}
                loading="lazy"
                style={{margin: '40px 40px 0px 40px', maxWidth: "800px",
                maxHeight: "350px",
                width: "auto",
                height: "auto",
                objectFit: "contain"}}
              />
              </div>

            <Paper className={classes.paper_details} elevation='4'>

            <Grid container>

            <Grid item xs={8} style={{padding: '0px 40px'}}>
              <Typography variant="body1" className={classes.head_title}>
                  <b>{title_variant}</b>
                </Typography>
            </Grid>
            <Grid item xs={4} style={{padding: '0px 40px', textAlign: 'right'}}>
              <Typography variant="body1" className={classes.head_price}>
                  <b>{price ? '€ ' + price : '€ --'}</b>
                </Typography>
              </Grid>
              </Grid>

                <Typography hidden variant="body2" className={classes.head_text} style={{whiteSpace: 'pre-line'}}>
                  {parseLines(description)}
                </Typography>

            <Paper className={classes.paper_details} elevation='4'>

            <Grid container style={{paddingBottom: '40px'}}>

              <Grid item xs={4} style={{textAlign: 'center'}}>
                <List>
                <ListItem>
                  <ListItemAvatar className={classes.item_list}>
                    <Avatar className={classes.icon}>
                      <NumbersIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText secondary={ean} primary='EAN' classes={{primary:classes.listItemText, secondary:classes.listItemText_secondary}} />
                </ListItem>
                <ListItem>
                    <ListItemAvatar className={classes.item_list}>
                      <Avatar className={classes.icon}>
                        <LocalOfferIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText secondary={brand} primary='Merk' classes={{primary:classes.listItemText, secondary:classes.listItemText_secondary}} />
                  </ListItem>
                  <ListItem>
                    <ListItemAvatar className={classes.item_list}>
                      <Avatar className={classes.icon}>
                        <CategoryIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText secondary={product_type} primary='Product type' classes={{primary:classes.listItemText, secondary:classes.listItemText_secondary}} />
                  </ListItem>
                </List>

                  </Grid>

                  <Grid item xs={4} style={{textAlign: 'center'}}>
                    <List>
                  <ListItem>
                    <ListItemAvatar className={classes.item_list}>
                      <Avatar className={classes.icon}>
                        <StraightenIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText secondary={size} primary='Maat' classes={{primary:classes.listItemText, secondary:classes.listItemText_secondary}} />
                  </ListItem>
                  <ListItem>
                    <ListItemAvatar className={classes.item_list}>
                      <Avatar className={classes.icon}>
                        <ColorLensIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText secondary={color} primary='Kleur' classes={{primary:classes.listItemText, secondary:classes.listItemText_secondary}} />
                  </ListItem>
                </List>

                </Grid>

                <Grid xs={4} style={{textAlign: 'center'}}>

              <List>
                <ListItem>
                  <ListItemAvatar className={classes.item_list}>
                    <Avatar className={classes.icon}>
                      <InventoryIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText secondary={stock} primary='Op voorraad' classes={{primary:classes.listItemText, secondary:classes.listItemText_secondary}} />
                </ListItem>
                <ListItem>
                  <ListItemAvatar className={classes.item_list}>
                    <Avatar className={classes.icon}>
                      <MyLocationIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText secondary={stock_location ? stock_location : '-'}  primary='Voorraad locatie' classes={{primary:classes.listItemText, secondary:classes.listItemText_secondary}} />
                </ListItem>
              </List>

              </Grid>

              </Grid>

            </Paper>

            </Paper>

            </Paper>

            :

            <div style={{minHeight: '450px', textAlign: 'center'}}>



              <img alt="Product_Search"
                src="https://aasproductimages.s3.eu-central-1.amazonaws.com/Pimly_Product_Search_Transparent.png"
                height="650px"
                loading="lazy"
                style={{margin: '40px 40px 0px 80px'}}
              />

            </div>
          }



            </Grid>

        </Grid>

      </div>

    </div>

    </Grid>

    </Grid>


    </div>

  )
}
else {
  return (
      <Homepage />
)
}
}


export default () => <Product />
